(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maison-inline-review-card"] && !Shopify.designMode) return;
  try {
    if (!window.maisonReviewMediaInitialized) {
    window.maisonReviewMediaInitialized = true;

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-maison-review-open]');
      if (openButton) {
        const dialog = openButton.closest('.maison-inline-review-card')?.querySelector('[data-maison-review-dialog]');
        if (dialog) dialog.showModal();
        return;
      }

      const closeButton = event.target.closest('[data-maison-review-close]');
      if (closeButton) {
        closeButton.closest('[data-maison-review-dialog]')?.close();
        return;
      }

      if (event.target.matches('[data-maison-review-dialog]')) event.target.close();
    });

    document.addEventListener('close', (event) => {
      if (!event.target.matches('[data-maison-review-dialog]')) return;
      event.target.querySelectorAll('video').forEach((video) => video.pause());
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-media-sale-badge')) {
    customElements.define(
      'product-media-sale-badge',
      class ProductMediaSaleBadge extends HTMLElement {
        connectedCallback() {
          this.image = this.parentElement?.querySelector('.product-media__image');
          if (!this.image) return;

          this.updatePosition = this.updatePosition.bind(this);
          this.image.addEventListener('load', this.updatePosition);
          this.resizeObserver = new ResizeObserver(this.updatePosition);
          this.resizeObserver.observe(this.parentElement);
          this.updatePosition();
        }

        disconnectedCallback() {
          this.image?.removeEventListener('load', this.updatePosition);
          this.resizeObserver?.disconnect();
        }

        updatePosition() {
          if (!this.image?.naturalWidth || !this.image?.naturalHeight || !this.parentElement) return;

          const parentRect = this.parentElement.getBoundingClientRect();
          const imageRect = this.image.getBoundingClientRect();
          const gap = Number.parseFloat(getComputedStyle(this).getPropertyValue('--pmg-gap')) || 16;
          const objectFit = getComputedStyle(this.image).objectFit;
          let right = gap;
          let top = gap;

          if (objectFit === 'contain') {
            const scale = Math.min(
              imageRect.width / this.image.naturalWidth,
              imageRect.height / this.image.naturalHeight
            );
            const renderedWidth = this.image.naturalWidth * scale;
            const renderedHeight = this.image.naturalHeight * scale;
            const renderedRight = imageRect.right - (imageRect.width - renderedWidth) / 2;
            const renderedTop = imageRect.top + (imageRect.height - renderedHeight) / 2;

            right = parentRect.right - renderedRight + gap;
            top = renderedTop - parentRect.top + gap;
          }

          this.style.setProperty('--pmg-right', `${Math.max(gap, right)}px`);
          this.style.setProperty('--pmg-top', `${Math.max(gap, top)}px`);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
